import { aeskw } from "@noble/ciphers/aes.js";

export function wrapKey(dek: Uint8Array, kek: Uint8Array): Uint8Array {
  if (dek.length !== 32 || kek.length !== 32) {
    throw new Error("aes_kw_requires_32_byte_keys");
  }
  return aeskw(kek).encrypt(dek);
}

export function unwrapKey(wrapped: Uint8Array, kek: Uint8Array): Uint8Array {
  if (kek.length !== 32) {
    throw new Error("aes_kw_requires_32_byte_kek");
  }
  return aeskw(kek).decrypt(wrapped);
}
